namespace Stores {
    export class SettingsStore {

        private static _current?: Entities.Settings;

        static async get(repository: RavenDbClient) {
            if (this._current != null)
                return this._current;

            try {
                const { document: document } = await repository.getDocument<Entities.Settings>(Entities.Settings.getId());
                this._current = document;
            } catch {
                this._current = new Entities.Settings();
            }

            return this._current;
        }

        static async set(repository: RavenDbClient) {
            if (this._current != null)
                await repository.saveDocument(this._current);
        }
    }
}